module.exports = __webpack_public_path__ + "images/dingtalk_qrcode_bj@2x-6b62230acdaa1c8b3a1ce643a4ebaea4.png";